enum PROTOCOL {
  HTTP = 'http',
  HTTPS = 'https',
}

let protocol: string;
let host: string;

switch (process.env.NODE_ENV) {
  case 'production':
    protocol = PROTOCOL.HTTP;
    host = `${protocol}://${process.env.REACT_APP_API_HOST}`;
    break;
  default:
    protocol = PROTOCOL.HTTP;
    host = `//${document.location.host}/api`;
    break;
}

export const apiBaseUrl = (): string => {
  return host;
};

export const initiateReferralUrl = (): string => {
  return `${host}/referral/initiate`;
};

export const listReferralsUrl = (agency: string): string => {
  return `${host}/referrals/list?agency=${encodeURI(agency)}`;
};
